import { createClient, type SupabaseClient } from "@supabase/supabase-js";

let browserClient: SupabaseClient | null = null;

function getSupabaseBrowserKey(): string {
  // Prefer legacy anon JWT (`eyJ…`) — required when Edge Functions verify JWT. Publishable (`sb_publishable_…`)
  // works for gateway + `functions.invoke` only if the function is deployed with `--no-verify-jwt`.
  return (
    import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() ||
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim() ||
    ""
  );
}

/**
 * Browser Supabase client (anon JWT preferred; publishable key if JWT verification is off on Edge).
 * Uses a singleton so the same instance is reused across the app.
 */
export function getSupabaseBrowserClient(): SupabaseClient | null {
  const url = import.meta.env.VITE_SUPABASE_URL?.trim() ?? "";
  const key = getSupabaseBrowserKey();
  if (!url || !key) {
    return null;
  }
  if (!browserClient) {
    browserClient = createClient(url, key, {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
      },
    });
  }
  return browserClient;
}

export function isSupabaseConfigured(): boolean {
  return Boolean(
    import.meta.env.VITE_SUPABASE_URL?.trim() && getSupabaseBrowserKey(),
  );
}
